import { Weekday } from '@occc/graphql';

export const CALENDAR_GRID_HOURS_24 = Array.from(
  { length: 24 },
  (_, i) => `${i.toString().padStart(2, '0')}:00`,
);

export const CALENDAR_GRID_HOURS_12 = Array.from({ length: 24 }, (_, i) => {
  const h = String(i % 12 === 0 ? 12 : i % 12).padStart(2, '0');
  return `${h}:00 ${i < 12 ? 'am' : 'pm'}`;
});

export const CALENDAR_GRID_DAYS = {
  [Weekday.Monday]: 'Monday',
  [Weekday.Tuesday]: 'Tuesday',
  [Weekday.Wednesday]: 'Wednesday',
  [Weekday.Thursday]: 'Thursday',
  [Weekday.Friday]: 'Friday',
  [Weekday.Saturday]: 'Saturday',
  [Weekday.Sunday]: 'Sunday',
};

export const CALENDAR_GRID_DAYS_START_FROM_SUNDAY = [
  Weekday.Sunday,
  Weekday.Monday,
  Weekday.Tuesday,
  Weekday.Wednesday,
  Weekday.Thursday,
  Weekday.Friday,
  Weekday.Saturday,
];

export const CALENDAR_GRID_DAYS_START_FROM_MONDAY = [
  ...CALENDAR_GRID_DAYS_START_FROM_SUNDAY.slice(1),
  ...CALENDAR_GRID_DAYS_START_FROM_SUNDAY.slice(0, 1),
];

export const CALENDAR_GRID_DEFAULTS = {
  color: '#ffffff',
  gridColor: '#969696',
  gridStep: 40,
  gridWidth: 1,
  timeColumnMinWidth: 56,
  dayColumnMinWidth: 175,
  dayItemColors: [
    '#6864D1',
    '#FF8F00',
    '#4696EC',
    '#4CAF50',
    '#F44336',
    '#F0F0FA',
    '#FFE9CC',
    '#DAEAFB',
    '#DBEFDC',
    '#FDD9D7',
  ],
  dayItemTextColors: [
    '#FFFFFF',
    '#FFFFFF',
    '#FFFFFF',
    '#FFFFFF',
    '#FFFFFF',
    '#6864D1',
    '#FF8F00',
    '#4696EC',
    '#4CAF50',
    '#F44336',
  ],
};
